"use client";

import { SafeUser, SafeChat, SimplifiedUser } from "@/app/types";
import Container from "../Container";
import Logo from "./Logo";
import Search from "./Search";
import UserMenu from "./UserMenu";
import Categories from "./Categories";
import { ExchangeCurrency } from "@prisma/client";
import CurrencyMenu from "./Currency";
import { useCallback, useEffect, useRef, useState } from "react";
import useRentModal from "@/app/hooks/useRentModal";
import { useRouter } from "next/navigation";
import Image from "next/image";

interface NavbarProps {
  currentUser?: SimplifiedUser | null;
  rates?: ExchangeCurrency | null;
  chats: {
    chats: SafeChat[] | null;
    totalPages: number;
    currentPage: number;
  };
}

const Navbar: React.FC<NavbarProps> = ({ currentUser, chats, rates }) => {
  const router = useRouter();
  const navbarRef = useRef<HTMLDivElement>(null);
  const rentModal = useRentModal();
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const [isCurrencyMenuOpen, setIsCurrencyMenuOpen] = useState(false);

  const toggleUserMenu = useCallback(() => {
    setIsUserMenuOpen((prev) => !prev);
    setIsCurrencyMenuOpen(false);
  }, []);

  const toggleCurrencyMenu = useCallback(() => {
    setIsCurrencyMenuOpen((prev) => !prev);
    setIsUserMenuOpen(false);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        navbarRef.current &&
        !navbarRef.current.contains(event.target as Node)
      ) {
        setIsUserMenuOpen(false);
        setIsCurrencyMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);


  return (
    <div className="fixed w-full bg-white z-10 shadow-sm pt-4 pb-1" ref={navbarRef}>
      <div
        className="border-b-[2px] border-gray-300"
      >
        <Container>
          <div
            className="flex flex-row items-center justify-between gap-3 md:gap-0 sm:mb-0 mb-6"
          >
            <Logo />
            <div className="flex flex-row items-center gap-3">
              {currentUser?.userType === "Center" && (
                <div
                  onClick={rentModal.onOpen}
                  className="hidden md:block text-sm font-semibold py-3 px-4 rounded-full hover:bg-neutral-100 transition cursor-pointer"
                >
                  List your courses
                </div>
              )}
              {!currentUser && (
                <div
                  onClick={() => router.push("/registercenter")}
                  className="hidden md:block text-sm font-semibold py-3 px-4 rounded-full hover:bg-neutral-100 transition cursor-pointer text-center"
                >
                  Register as a DIVE CENTER
                </div>
              )}
              <CurrencyMenu
                currentUser={currentUser}
                isOpen={isCurrencyMenuOpen}
                toggleOpen={toggleCurrencyMenu}
              />
              <UserMenu
                currentUser={currentUser}
                isOpen={isUserMenuOpen}
                toggleOpen={toggleUserMenu}
                chatsData={chats}
              />
            </div>
          </div>
        </Container>
        <Search
          currentUser={currentUser}
          rates={rates}
        />
      </div>
      <Categories />
    </div>
  );
};

export default Navbar;
